module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 008.90f91caa.jpg";